<template>
    <div style="height: 100%;">
        <el-row :gutter="20" class="container">
            <el-col :span="24" class="container" style="flex-direction: column;border-width: 0;padding-top: 25px;">
                <el-form :model="queryParams" ref="queryForm" :inline="true" label-position="right" v-show="showSearch" label-width="100px">
                    <el-form-item label="日志类型" prop="logType">
                        <enum-dict-select v-model="queryParams.param.logType" dict-code="accessLogType" module-name="system" placeholder="请选择日志类型" size="small" clearable style="width: 150px;"></enum-dict-select>
                    </el-form-item>
                    <el-form-item label="用户名" prop="username">
                        <el-input v-model="queryParams.param.username" placeholder="请输入用户名" size="small" clearable style="width: 150px;"></el-input>
                    </el-form-item>
                    <el-form-item label="IP地址" prop="ip">
                        <el-input v-model="queryParams.param.ip" placeholder="请输入IP地址" size="small" clearable style="width: 150px;"></el-input>
                    </el-form-item>
                    <el-form-item label="请求URL" prop="requestUrl">
                        <el-input v-model="queryParams.param.requestUrl" placeholder="请输入URL关键词" size="small" clearable style="width: 200px;"></el-input>
                    </el-form-item>
                    <el-form-item label="操作状态" prop="status">
                        <enum-dict-select v-model="queryParams.param.status" dict-code="accessLogStatus" module-name="system" placeholder="请选择状态" size="small" clearable style="width: 120px;"></enum-dict-select>
                    </el-form-item>
                    <el-form-item label="时间范围" prop="createDate">
                        <el-date-picker
                            v-model="dateRange.createDate"
                            type="datetimerange"
                            range-separator="至"
                            start-placeholder="开始时间"
                            end-placeholder="结束时间"
                            size="small"
                            style="width: 360px;">
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" icon="el-icon-search" size="small" @click="handleSearch">搜索</el-button>
                        <el-button icon="el-icon-refresh" size="small" @click="handleReset">重置</el-button>
                    </el-form-item>
                </el-form>

                <el-row :gutter="10" style="margin-bottom:13px;margin-right: 1px">
                    <el-col :span="1.5">
                        <el-button type="warning" plain icon="el-icon-refresh-left" size="small" @click="handleRefresh">刷新</el-button>
                    </el-col>
                    <el-col :span="1.5">
                        <el-button type="success" plain icon="el-icon-download" size="small" @click="handleExport">导出日志</el-button>
                    </el-col>
                    <right-toolbar-plus :showSearch.sync="showSearch" @queryTable="handleSearch"
                                        :columnInfo="columnInfo" @redoTableLayout="redoTableLayout"></right-toolbar-plus>
                </el-row>

                <el-row :gutter="15" style="margin-bottom: 15px;">
                    <el-col :span="6">
                        <el-card shadow="hover" style="background: linear-gradient(135deg, #667eea 0%, #764ba2 100%); color: white;">
                            <div style="display: flex; justify-content: space-between; align-items: center;">
                                <div>
                                    <div style="font-size: 14px; opacity: 0.9;">今日访问量</div>
                                    <div style="font-size: 28px; font-weight: bold; margin-top: 5px;">{{ statistics.todayVisitCount }}</div>
                                </div>
                                <i class="el-icon-view" style="font-size: 48px; opacity: 0.4;"></i>
                            </div>
                        </el-card>
                    </el-col>
                    <el-col :span="6">
                        <el-card shadow="hover" style="background: linear-gradient(135deg, #f093fb 0%, #f5576c 100%); color: white;">
                            <div style="display: flex; justify-content: space-between; align-items: center;">
                                <div>
                                    <div style="font-size: 14px; opacity: 0.9;">登录用户数</div>
                                    <div style="font-size: 28px; font-weight: bold; margin-top: 5px;">{{ statistics.todayLoginUserCount }}</div>
                                </div>
                                <i class="el-icon-user" style="font-size: 48px; opacity: 0.4;"></i>
                            </div>
                        </el-card>
                    </el-col>
                    <el-col :span="6">
                        <el-card shadow="hover" style="background: linear-gradient(135deg, #4facfe 0%, #00f2fe 100%); color: white;">
                            <div style="display: flex; justify-content: space-between; align-items: center;">
                                <div>
                                    <div style="font-size: 14px; opacity: 0.9;">接口成功率</div>
                                    <div style="font-size: 28px; font-weight: bold; margin-top: 5px;">{{ statistics.todaySuccessRate }}</div>
                                </div>
                                <i class="el-icon-ok" style="font-size: 48px; opacity: 0.4;"></i>
                            </div>
                        </el-card>
                    </el-col>
                    <el-col :span="6">
                        <el-card shadow="hover" style="background: linear-gradient(135deg, #fa709a 0%, #fee140 100%); color: white;">
                            <div style="display: flex; justify-content: space-between; align-items: center;">
                                <div>
                                    <div style="font-size: 14px; opacity: 0.9;">平均响应时间</div>
                                    <div style="font-size: 28px; font-weight: bold; margin-top: 5px;">{{ statistics.todayAvgExecuteTime }}</div>
                                </div>
                                <i class="el-icon-time" style="font-size: 48px; opacity: 0.4;"></i>
                            </div>
                        </el-card>
                    </el-col>
                </el-row>

                <div class="main">
                    <div class="table">
                        <el-table border ref="logTable" :data="tableData" tooltip-effect="dark" style="width: 100%"
                                  height="100%" :header-cell-style="{background:'#ECF5FF'}" @row-click="handleRowClick">
                            <el-table-column align="center" type="index" label="序号" width="60"/>
                            <el-table-column align="center" prop="logType" label="日志类型" width="100" v-if="columnInfo.logType.visible">
                                <template v-slot="scope">
                                    <enum-dict-label v-model="scope.row.logType" dict-code="accessLogType" module-name="system" show-tag></enum-dict-label>
                                </template>
                            </el-table-column>
                            <el-table-column align="center" prop="username" label="用户名" width="120" v-if="columnInfo.username.visible"/>
                            <el-table-column align="center" prop="operation" label="操作描述" width="180" show-overflow-tooltip v-if="columnInfo.operation.visible"/>
                            <el-table-column align="center" prop="method" label="请求方法" width="90" v-if="columnInfo.method.visible">
                                <template v-slot="scope">
                                    <el-tag :type="getMethodTag(scope.row.method)" size="mini">
                                        {{ scope.row.method }}
                                    </el-tag>
                                </template>
                            </el-table-column>
                            <el-table-column align="center" prop="requestUrl" label="请求URL" min-width="200" show-overflow-tooltip v-if="columnInfo.requestUrl.visible"/>
                            <el-table-column align="center" prop="ip" label="IP地址" width="130" v-if="columnInfo.ip.visible"/>
                            <el-table-column align="center" prop="location" label="IP归属地" width="120" show-overflow-tooltip v-if="columnInfo.location.visible"/>
                            <el-table-column align="center" prop="status" label="状态" width="80" v-if="columnInfo.status.visible">
                                <template v-slot="scope">
                                    <enum-dict-label v-model="scope.row.status" dict-code="accessLogStatus" module-name="system" show-tag></enum-dict-label>
                                </template>
                            </el-table-column>
                            <el-table-column align="center" prop="executeTime" label="执行时长" width="90" v-if="columnInfo.executeTime.visible">
                                <template v-slot="scope">
                                    <span :style="{color: scope.row.executeTime > 1000 ? '#f56c6c' : '#67c23a'}">
                                        {{ scope.row.executeTime }}ms
                                    </span>
                                </template>
                            </el-table-column>
                            <el-table-column align="center" prop="createDate" label="记录时间" width="170" v-if="columnInfo.createDate.visible"/>
                            <el-table-column align="center" label="操作" width="100" fixed="right">
                                <template v-slot="scope">
                                    <el-button type="text" size="mini" icon="el-icon-view" @click.stop="handleViewDetail(scope.row)">详情</el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                </div>

                <div style="height: 40px;margin-bottom: 0.1rem;">
                    <pagination-plus :totalCount="totalCount"
                                     :param="queryParams"
                                     :pageSizes="pageSizes"
                                     :selectList="selectList"
                                     module-name="system"
                                     table-name="accessLog"
                                     @handleTableRefresh="handleSearch"/>
                </div>
            </el-col>
        </el-row>

        <AccessLogForm :visible.sync="detailDialogVisible" :edit-data="currentLog"/>
    </div>
</template>

<script>
import {mapState, mapActions} from "vuex";
import AccessLogForm from "./AccessLogForm";

export default {
    name: "SystemLog",
    components: {
        AccessLogForm
    },
    data() {
        return {
            // 展示搜索区（right-toolbar）
            showSearch: false,
            // 每页条数选项（分页控件）
            pageSizes: [10, 20, 40, 80, 100],
            // 批量操作选中list（分页控件）
            selectList: [],
            detailDialogVisible: false,
            currentLog: null
        }
    },
    computed: {
        ...mapState({
            tableData: state => state.system.accessLog.tableData,
            totalCount: state => state.system.accessLog.totalCount,
            columnInfo: state => state.system.accessLog.columnInfo,
            queryParams: state => state.system.accessLog.queryParams,
            dateRange: state => state.system.accessLog.dateRange,
            statistics: state => state.system.accessLog.statistics
        })
    },
    created() {
        this.handleTableSearch();
        this.getStatistics();
    },
    methods: {
        ...mapActions({
            handleTableSearch: 'system/accessLog/handleTableSearch',
            getStatistics: 'system/accessLog/getStatistics'
        }),
        getMethodTag(method) {
            const tagMap = {
                'GET': 'success',
                'POST': 'primary',
                'PUT': 'warning',
                'DELETE': 'danger'
            };
            return tagMap[method] || 'info';
        },
        handleSearch() {
            this.handleTableSearch();
        },
        handleReset() {
            this.queryParams.param = {
                logType: undefined,
                username: undefined,
                ip: undefined,
                requestUrl: undefined,
                status: undefined
            };
            this.dateRange.createDate = [];
            this.$nextTick(() => {
                this.handleTableSearch();
            });
            this.$message.info('重置完成');
        },
        handleRefresh() {
            this.handleTableSearch();
            this.getStatistics();
            this.$message.success('刷新成功');
        },
        handleExport() {
            this.$message.info('导出功能待实现');
        },
        handleRowClick(row) {
        },
        handleViewDetail(row) {
            this.currentLog = row;
            this.detailDialogVisible = true;
        },
        redoTableLayout() {
            this.$nextTick(() => {
                this.$refs.logTable.doLayout();
            });
        }
    }
}
</script>

<style lang="less" scoped>
@import url('~@/assets/style/index.less');

::v-deep .el-form-item {
    margin-bottom: 18px;
}
</style>
